import { useState } from "react";
import Compressor from "compressorjs";
import { baseurl } from "../functions/constants";
import axios from "axios";

const GuardarIne = ({ id_usuario, setCapturarIne, tipoCaptura }) => {
	const [selectedFile, setSelectedFile] = useState(null);
	const [id, setId] = useState(id_usuario);
	const [tipoC, setTipoC] = useState(tipoCaptura);
	// const [compressedFile, setCompressedFile] = useState(null);

	const onFileChange = (event) => {
		setSelectedFile(event.target.files[0]);
	};

	const onFileUpload = () => {
		if (selectedFile) {
			new Compressor(selectedFile, {
				quality: 0.5,
				success: (compressedResult) => {
					console.log("tipoCaptura", tipoC);
					const formData = new FormData();
					formData.append("image", compressedResult, selectedFile.name);
					formData.append("id", id);
					formData.append("tipoCaptura", tipoC);
					const url = `${baseurl}/captureIne`;
					axios
						.post(url, formData)
						.then((response) => {
							if (response.status === 200) {
								alert("Imagen guardada");
							} else {
								alert("Error al guardar imagen");
							}
							setSelectedFile(null);
							cancelIne();
						})
						.catch((error) => {
							console.error("error", error);
						});
				},
			});
		} else {
			alert("Seleccione una imágen válida");
		}
	};

	const cancelIne = () => {
		setCapturarIne(0);
		setId("");
		setTipoC("");
	};

	const fileData = () => {
		if (selectedFile) {
			return (
				<div className="flex flex-col justify-center w-full h-full mt-6">
					<div className="text-center ">
						<div className="text-xl">Detalles:</div>
						<div>Nombre del archivo: {selectedFile.name}</div>
						<div>Tipo: {selectedFile.type}</div>
					</div>
				</div>
			);
		}
	};

	return (
		<div className="px-4 py-5 mx-4 mb-8 bg-white shadow sm:rounded-lg sm:p-6">
			<div className="text-3xl text-center">Captura de imágenes</div>
			<div className="text-2xl text-center">{id_usuario}</div>
			<br />
			<div className="mx-2">
				<input
					type="file"
					onChange={onFileChange}
					className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
				/>
			</div>
			{fileData()}
			<div className="flex flex-row justify-center w-full h-full mt-6">
				<button
					onClick={cancelIne}
					className={
						selectedFile
							? "btn-gray-blue mx-3"
							: "px-3 py-1 text-gray-100 bg-gray-500 shadow-lg rounded-xl text-light mx-3"
					}
				>
					Cancelar
				</button>
				<button
					onClick={() => onFileUpload()}
					className={
						selectedFile
							? "btn-gray-blue mx-3"
							: "px-3 py-1 text-gray-100 bg-gray-500 shadow-lg rounded-xl text-light mx-3"
					}
				>
					Cargar archivo
				</button>
			</div>
		</div>
	);
};

export default GuardarIne;
